module.exports = __webpack_public_path__ + "static/media/hammer-war.df3cce29.svg";